import { render } from "./SetPage.vue?vue&type=template&id=701034be"
import script from "./SetPage.vue?vue&type=script&lang=js"
export * from "./SetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__